import * as React from 'react';
import { WalletNavigationContext } from './WalletNavigationContext';
import { createWalletNavigationStore } from './createWalletNavigationStore';

export function WithWalletNavigation<TProps>(Component: React.FC<TProps>): React.FC<React.PropsWithRef<TProps>> {
    const MemoizedComponent = React.memo<React.FC<TProps>>(Component);

    const ComponentWithWalletNavigation: React.FC<React.PropsWithRef<TProps>> = props => {
        const [walletNavigationStore] = React.useState(() => createWalletNavigationStore());

        return (
            <WalletNavigationContext.Provider value={{ walletNavigationStore }}>
                <MemoizedComponent {...props} />
            </WalletNavigationContext.Provider>
        );
    };

    ComponentWithWalletNavigation.displayName = `${Component.displayName || 'Component'}WithWalletNavigation`;

    return ComponentWithWalletNavigation;
}
